module.exports = __webpack_public_path__ + "static/media/photo5@2x.b62f06ed.jpg";